import type { TagRef } from '@neuroedge/shared';

/** Read-only coloured chips for a list of tags. */
export function TagChips({
  tags,
  empty = null,
}: {
  tags: TagRef[] | undefined;
  empty?: React.ReactNode;
}) {
  const list = tags ?? [];
  if (list.length === 0) return <>{empty}</>;
  return (
    <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 'var(--space-1)' }}>
      {list.map((t) => (
        <TagChip key={t.id} tag={t} />
      ))}
    </span>
  );
}

export function TagChip({ tag }: { tag: TagRef }) {
  const color = tag.color ?? '#64748b';
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '2px 8px',
        borderRadius: 999,
        fontSize: 'var(--font-size-sm)',
        lineHeight: 1.4,
        background: `${color}1a`,
        color,
        border: `1px solid ${color}55`,
        whiteSpace: 'nowrap',
      }}
    >
      <span
        aria-hidden
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: color,
          display: 'inline-block',
        }}
      />
      {tag.name}
    </span>
  );
}
